import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type {
  GetFilesAttachedToTransmittalRequest,
  GetFilesAttachedToTransmittalResponse,
  GetTransmittalDataByIdRequest,
  GetTransmittalDataByIdResponse,
  GetTransmittalFileVersionsForSpaceRequest,
  GetTransmittalFileVersionsForSpaceResponse,
  IsTransmittal403Request,
  IsTransmittal403Response,
  SaveTransmittalsRequest,
  SaveTransmittalsResponse,
} from "@ServerTypes/transmittals/transmittals.schema";

export const saveTransmittalsDataRequest = (data: SaveTransmittalsRequest) =>
  axiosWrapper.post<SaveTransmittalsResponse>(`${getBackendUrl()}/transmittals/saveTransmittalsData`, data);

export const getTransmittalAttachedFilesRequest = (data: GetFilesAttachedToTransmittalRequest) =>
  axiosWrapper.post<GetFilesAttachedToTransmittalResponse>(
    `${getBackendUrl()}/transmittals/getFilesAttachedToTransmittal`,
    data,
  );

export const checkTransmittalAccessRequest = (data: IsTransmittal403Request) =>
  axiosWrapper.post<IsTransmittal403Response>(`${getBackendUrl()}/transmittals/isTransmittal403`, data);

export const getTransmittalFileVersionsForSpaceRequest = (data: GetTransmittalFileVersionsForSpaceRequest) =>
  axiosWrapper.post<GetTransmittalFileVersionsForSpaceResponse>(
    `${getBackendUrl()}/transmittals/getTransmittalFileVersionsForSpace`,
    data,
  );

export const getTransmittalDataByIdRequest = (data: GetTransmittalDataByIdRequest) =>
  axiosWrapper.post<GetTransmittalDataByIdResponse>(`${getBackendUrl()}/transmittals/getTransmittalDataById`, data);
